import { useState } from 'react';
import H5 from 'UIComponents/elements/headings/H5';
import ResponseFooter from 'developer-docs-shared-components/components/endpoint/ResponseFooter';
import UITable from 'UIComponents/table/UITable';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledTableHead = styled.thead.withConfig({
  displayName: "EndpointJSONFields__StyledTableHead",
  componentId: "sc-1volgc2-0"
})(["background-color:GYPSUM;"]);

/**
 * Example children prop (from legacy mdx docs):
 * const children = [
 *   { props: { children: 'JSON Fields returned in the response' } },
 *   {
 *     props: {
 *       children: [
 *         {
 *           props: {
 *             type: 'thead',
 *             children: { type: 'tr' },
 *           },
 *         },
 *         {
 *           props: {
 *             type: 'tbody',
 *             children: [{ type: 'tr' }],
 *           },
 *         },
 *       ],
 *     },
 *   },
 * ];
 */

/*
  Used specifically for legacy/v1 API MDX docs for the JSON Fields returned
  in the response sections. Attempts to mirror the look and feel of the
  EndpointExample component.
*/
const EndpointJSONFields = ({
  children
}) => {
  const [expanded, setExpanded] = useState(false);
  const sectionHeader = children[0].props.children;
  const tableHeaderRow = children[1].props.children[0].props.children;
  const tableBody = children[1].props.children[1];
  return /*#__PURE__*/_jsxs("div", {
    className: "response-panel m-bottom-4",
    children: [/*#__PURE__*/_jsx(H5, {
      className: "response-header",
      children: sectionHeader
    }), /*#__PURE__*/_jsxs(UITable, {
      flush: true,
      bordered: true,
      height: expanded ? 'auto' : '400px',
      children: [/*#__PURE__*/_jsx(StyledTableHead, {
        children: tableHeaderRow
      }), tableBody]
    }), /*#__PURE__*/_jsx(ResponseFooter, {
      expanded: expanded,
      onClick: () => setExpanded(!expanded)
    })]
  });
};
export default EndpointJSONFields;